import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import { defaultTableOptions } from '../../../../constants/tableOptions';

import warningImage from '../../../../assets/img/brand/warning.svg';

const tableOptions = {
  ...defaultTableOptions,
  sizePerPage: 10,
};

const ProtocoloMassaModalError = ({
  labelType,
  onClose,
  isOpen,
  errors = [],
}) => {
  const textoHeader = labelType.toLowerCase() === 'contrato' ? `Os ${labelType.toLowerCase()}s abaixo não podem ser inseridos` : `As ${labelType.toLowerCase()}s abaixo não podem ser inseridas`;

  return (
    <Modal isOpen={isOpen} size="lg">
      <ModalHeader
        className="modal-header--info modal-header-protocolo-massa-erro">
        {textoHeader}
        {' '}
        neste tipo de protocolo.
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col sm="12" className="text-center">
            <img src={warningImage} width="80px" alt="Icone de aviso" />
          </Col>
        </Row>
        <Row className="row_protocolo mt-3">
          <Col sm="12">
            <BootstrapTable
              version="4"
              striped
              pagination
              data={errors}
              options={tableOptions}
            >
              <TableHeaderColumn
                dataField="NumeroContrato"
                isKey
                width="120px"
              >
                {labelType}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="message"
              >
                Motivo
              </TableHeaderColumn>
            </BootstrapTable>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col sm="12" className="text-right">
            <Button
              type="button"
              color="danger"
              className="btn_danger"
              onClick={() => !!onClose && onClose()}
            >
              Fechar
            </Button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export { ProtocoloMassaModalError };
